import { useContext } from "react";
import { SocketContext } from "../context/SocketContext";

export const useProvideSocket = () => {
  const { online, socket, traerGruposEffect } = useContext(SocketContext);
  return { online, socket, traerGruposEffect };
};
